import React from "react"
import { Redirect } from "react-router-dom"

import { LoginWithSamlScreenContent } from "./ScreenContent"
import { useCustomerInfo } from "../../../CustomerInfo/context"

export const LoginWithSamlProtectedScreenContent = () => {
  const { data } = useCustomerInfo()
  return data?.saml?.enabled ? <LoginWithSamlScreenContent/> : <Redirect to="/"/>
}